export class ActivityByStatus
{
    constructor (public server: string, public master: string, public statusClass: string, public nbStatusJobs: number)
    {
    }
}
